import useStore from "./useStore";

export const createMenuSlice = (set) => ({
  miniProfile: false,
  about: false,
  askQuestion: false,
  toggleField: (field) => set((state) => ({ [field]: !state[field] })),
  closeField: (field) => set(() => ({ [field]: false })),
  openField: (field) => set(() => ({ [field]: true })),
});

export const useAbout = () => useStore((state) => state.about);
export const useMiniprofile = () => useStore((state) => state.miniProfile);
export const useAskQuestion = () => useStore((state) => state.askQuestion);
export const useToggleField = () => useStore((state) => state.toggleField);
export const useCloseField = () => useStore((state) => state.closeField);
export const useOpenField = () => useStore((state) => state.openField);
